/** @format */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
import React from 'react';
import { createRoot } from 'react-dom/client';
import Footer from './footer';

/**
 * Build Footer.
 */
export const footer = (): void => {
  const footer: HTMLElement | null = document.getElementById('varian-footer');
  if (footer) {
    const root = createRoot(footer);
    root.render(React.createElement(Footer));
  }
};
